<div>
  <div class="text-center mb-5">
    <h1 class="mb-5 px-3">
      <strong>Herzlich willkommen auf der Generischen Studienplattform</strong>
    </h1>

  </div>
  <div class="card boxContainer">
    <div class="text-dark font-size-24 mb-3">
      <strong></strong>
    </div>
    <div class="mb-4">
      <nz-radio-group [ngModel]="authProvider" (ngModelChange)="setProvider($event)">

      </nz-radio-group>
    </div>
    <form nz-form [nzLayout]="'vertical'" [formGroup]="form" (ngSubmit)="submitForm()" role="form">
      <nz-form-item>
        <nz-form-control nzErrorTip="Bitte geben Sie ihren Benutzernamen oder ihre E-mail ein!">
          <input type="text" nz-input formControlName="email" nzSize="large" placeholder="Benutzername" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control nzErrorTip="Bitte geben Sie ihr Passwort ein!">
          <input type="password" nz-input nzSize="large" formControlName="password" placeholder="Passwort" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control>
          <button nz-button nzType="primary" [nzSize]="'large'" [nzLoading]="loading" class="text-center w-100">
            <strong>{{ 'actions.login' | translate }}</strong>
          </button>
        </nz-form-control>
      </nz-form-item>
    </form>
    <a routerLink="/auth/forgot-password" class="kit__utils__link font-size-16">

    </a>
  </div>
  <div class="text-center pt-2 mb-auto">
    <span class="mr-2"></span>
    <a routerLink="/auth/register" class="kit__utils__link font-size-16">

    </a>
  </div>
</div>
